var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiSelectTall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61.378616mm",
    height: "12.586603mm",
    viewBox: "0 0 61.378616 12.586603",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-382.68626,-279.49359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(1.6975572,0,0,1.6975572,-212.69053,-156.22253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "UI_Select_disabled",
    d: "m 352.24952,256.67242 -1.5239,3.69686 1.44366,3.71768 33.08473,-0.0237 1.62863,-3.09624 -1.40701,-3.80949 z",
    fill: "#b098ab",
    style: {
      fill: "#59194b",
      fillOpacity: 1,
      strokeWidth: 0.137048
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiSelectTall);
export default __webpack_public_path__ + "static/media/UI_Select_Tall.0ddef90f27f6a21a64398fc5f407b17b.svg";
export { ForwardRef as ReactComponent };